import dynamic from "next/dynamic";

// only render the code editor on the client
const CodeEditor = dynamic(() => import("./Editor"), { ssr: false });

export default CodeEditor;
